<template>
  <div class="row home-event-list" @click="navigate">
    <div class="left">
      <div class="title">{{data.title}}</div>
      <div class="count">{{data.count}}条相关新闻</div>
    </div>
    <div class="right">
      <span class="index">{{data.heat}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    navigate() {
      this.$router.push({
        name: 'event-detail',
        query: {
          name: this.data.title,
          id: this.data.id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  .home-event-list {
    padding: 24px 24px 25px 32px;
    border-bottom: 1px solid #333138;
    background-color: #3e3c42;
    cursor: pointer;
    &:hover {
      background-color: #29272e;
    }
    .left {
      flex: 1;
      .title {
        padding-bottom: 8px;
        color: #ffffff;
        font-size: 16px;
      }
      .count {
        color: rgba(255, 255, 255, 0.7);
        font-size: 14px;
      }
    }
    .right {
      width: 61px;
      margin-left: 20px;
      .index {
        float: right;
        color: #ffe536;
        font-size: 24px;
        font-family: Roboto-MediumItalic;
      }
    }
  }
</style>



